import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-server-error-page',
  templateUrl: './server-error-page.component.html',
})
export class ServerErrorPageComponent implements OnInit {
  constructor() {}

  ngOnInit() {}
}
